import { render, staticRenderFns } from "./FullTabs.vue?vue&type=template&id=2fb61e41&scoped=true"
import script from "./FullTabs.vue?vue&type=script&lang=js"
export * from "./FullTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb61e41",
  null
  
)

export default component.exports